<div class="cms-bonus-code">
  <button id="bonusCodeInformation" class="d-none"
          data-bs-toggle="modal" data-bs-target="#modalBonusCodeInformation">
  </button>
  <a
    href="javascript:void(0)"
    class="text-blue-lighter d-none"
    data-bs-toggle="modal"
    data-bs-target="#modalBonusCodeInformation"
    create-permission
  >View Bonus</a>
  <div class="modal fade fx-modal" id="modalBonusCodeInformation">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-shadow">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h2 class="modal-title font-bold" style="margin-bottom: 0">
            Current Applied Bonus
          </h2>
          <div
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            &times;
          </div>
        </div>

        <!-- Modal body -->
        <div class="modal-body ">
          <table class="rox-table table-bordered bg-dark">
            <thead>
            <tr>
              <th class="text-center">Account No.</th>
              <th class="text-center">Promotion Code</th>
              <th class="text-center">How to get a promotion code</th>
              <th class="text-center">Bonus Content</th>
              <th class="text-center">Expiration date</th>
              <th class="text-center">Status</th>
              <!--<th class="text-center"></th>-->
            </tr>
            </thead>
            <tbody *ngIf="datas.length > 0">
              <tr
              *ngFor="
                let item of datas
                  | paginate
                    : {
                        id: 'bonus_code_history',
                        itemsPerPage: pageInfo.pageSize,
                        currentPage: pageInfo.pageIndex,
                        totalItems: pageInfo.totalRecord
                      }
              "
            >
                <td class="text-center">{{item?.login}}</td>
              <td class="text-center text-blue">
                {{item.code}}
              </td>
              <td class="text-center">
                <span *ngIf="item.is_enable_account">{{'Open Account'}}</span>
                <span *ngIf="item.is_enable_account && item.is_enable_deposit"> / </span>
                <span *ngIf="item.is_enable_deposit">{{'Deposit'}}</span>
              </td>
              <td class="text-center">
                <ng-container *ngIf="item.is_enable_deposit">
                  <div class="fs-13 text-yellow"
                       *ngFor="let condition of item.data.deposit.conditions" style="white-space: nowrap">
                    <ng-container *ngIf = "condition.rate > 0 && condition.threshold >= 0">
                      <span> ~ </span>
                      <span>
                      <span labelNumber="{{condition.threshold }}" [currency]="'jpy'"></span> JPY | </span>
                      <span>{{'Bonus'}}: </span>
                      <span><span labelNumber="{{(condition.rate * 100)}}" [currency]="'per'"></span> %</span>
                    </ng-container>
                  </div>
                </ng-container>
              </td>
              <td
                class="text-center">
                <span>{{item.start_time | date: 'yyyy/MM/dd HH:mm'}}</span>
                <span> - </span>
                <span>{{item.end_time | date: 'yyyy/MM/dd HH:mm'}}</span>
              </td>

              <td class="text-center text-{{
                  item.status == 1
                    ? 'yellow'
                    : item.status == 2
                    ? 'red'
                    : 'grey'
                }}">{{ "BONUS_STATUS." + item.status | translate }}</td>


              <!--<td class="text-center text-{{(item.status == 1) ? 'yellow' : (item.status == 2) ? 'red' : 'grey' }}">
                {{getLabel(item.status)}}
              </td>-->
              <!--<td class="text-center">
                <input type="checkbox" [(ngModel)]="item.mode" (change)="onUpdateMode(item)"/>
              </td>-->
            </tr>
            </tbody>
          </table>
          <div class="clearfix mt-15">
            <div class="pagination-wrapper">
              <pagination-controls
                id="bonus_code_history"
                (pageChange)="pageChanged($event)"
                autoHide="true"
                responsive="true"
                previousLabel="Prev"
                nextLabel="Next"
              >
              </pagination-controls>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
